// src/app/components/loader/SnakeLoader.tsx

import React from 'react';
import styles from './SnakeLoader.module.scss';

const SnakeLoader: React.FC = () => {
  return <div className={styles.loader}></div>;
};

export default SnakeLoader;
